// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    startMention: {
        defaultMessage: 'Mention someone to notify them',
        description: 'Message to display when a user triggers a mention',
        id: 'boxui.draftjs.mentionSelector.startMention',
    },
});

export default messages;
